/* Drop the cents from displayed prices storewide: $99.99 shows as $99.
   Truncates, never rounds, so $99.99 can never become $100.

   Self-contained on purpose so it works on any version of the theme: it does
   not touch Liquid money filters or any template. It rewrites price TEXT as
   it appears, and a MutationObserver catches everything rendered later - the
   cart drawer re-rendering, quick add, variant changes, JS-built cards.

   A text node is only touched when the WHOLE node is a price ("$99.99",
   "From $24.99", "$1,299.00 USD"). Prices embedded mid-sentence are left
   alone, which keeps things like shipping-threshold copy exact. Values in
   inputs, data attributes, scripts, and anything sent to checkout are never
   affected - this is display only, and Shopify's checkout pages are theirs
   to render, so cents remain there.

   Install: upload as assets/tt-price-format.js, then add before </body> in
   layout/theme.liquid:
     <script src="{{ 'tt-price-format.js' | asset_url }}" defer="defer"></script>
*/
(function () {
  var MONEY = /^\s*(From\s+)?\$\s?\d{1,3}(?:,\d{3})*\.\d{2}(\s*USD)?\s*$/i;
  var CENTS = /\.\d{2}(?=\s*(USD)?\s*$)/i;

  function strip(node) {
    node.nodeValue = node.nodeValue.replace(CENTS, '');
  }

  function walk(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var node;
    while ((node = walker.nextNode())) {
      if (MONEY.test(node.nodeValue)) strip(node);
    }
  }

  function run() {
    walk(document.body);

    /* Re-rendered and late content. Stripping a node stops it matching, so
       the observer settles instead of looping. */
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData') {
          if (MONEY.test(m.target.nodeValue)) strip(m.target);
          continue;
        }
        for (var j = 0; j < m.addedNodes.length; j++) {
          var added = m.addedNodes[j];
          if (added.nodeType === 1) walk(added);
          else if (added.nodeType === 3 && MONEY.test(added.nodeValue)) strip(added);
        }
      }
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
